(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name crewExpiryLogReport.controller:CrewExpiryLogReportCtrl
   *
   * @description
   *
   */
  angular
    .module('crewExpiryLogReport')
    .controller('CrewExpiryLogReportCtrl', CrewExpiryLogReportCtrl);

  function CrewExpiryLogReportCtrl(CommonMasterData, $sce, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'CrewExpiryLogReportCtrl';
    vm.model = {
      searchPanelToggle: true,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        leaveTypes: [],
        crewType: null,
        crewId: null,
        crew: null,
        validation : null
      },
      masterList: {
        crewTypeList: [],
        crewList: [],
        leaveTypeList: [],
        validationTypes : [],
        fromTimeInvalid: false,
        toTimeInvalid: false,
        validations : []
      },
      initialSearchDone: false,
      reportDataURL: null,
      reportServerBaseUrl: null
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    vm.submitSearch = function (params) {
      searchLeaveDetailsReport(params);
    };

    function searchLeaveDetailsReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;

        var rptDesign = "crew_expiry_log_report.rptdesign";


        var url = CommonLogicService.getReportUrl(rptDesign, getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }

    vm.loadCrewID = function () {
      vm.model.searchCriteria.crewId = vm.model.searchCriteria.crew.crewId;
    };

    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["crewTypeCode"] = param.crewType.crewTypeCode;
      searchParamMap["validationTypeCode"] = param.validationType.code;
      if(!!param.validation){
        searchParamMap["validationId"] = param.validation.id;
      }
      searchParamMap["referrer"] = window.location.origin;
      return searchParamMap;
    }

    function isValidSearchParams(params) {
      if ((!!vm.model.searchCriteria.crewType &&  !!vm.model.searchCriteria.validationType)
      ) {
        return true;
      }
      return false;
    }


    (function loadCrewTypes() {
      CommonMasterData.getCrewTypeList(
        function (crewTypes) {
          vm.model.masterList.crewTypeList = crewTypes;
          // vm.model.masterList.msgRecipients = crewTypes;
        },
        function () {
          console.log('Crew type retrieval error');
        }
      );
    })();


    vm.changeSearchField = function(searchParams, flag) {
      if (flag === 'validationType') {
        vm.model.masterList.validations = loadValidaitonList(searchParams);
        if (!!searchParams.validationType
          && vm.model.searchCriteria.validation != undefined) {
          vm.model.searchCriteria.validation = undefined;
        }
      }
    };

    function loadValidaitonList(searchParams) {

      if (!!searchParams.validationType) {
        vm.model.validationReqObj = GetFormattedValidationRequest(searchParams);
        CommonMasterData.loadValidationList(vm.model.validationReqObj,
          function(response) {
            vm.model.masterList.validations = response;
          }, function() {
            console.log('Validation List retrieval error');
          });
      } else {
        vm.model.masterList.validations = [];
      }
    };

    function ValidationRequestDTO(){
      this.validationType = null;
      this.crewType = null;
    }

    function GetFormattedValidationRequest(searchParam){

      var valReq = new ValidationRequestDTO();

      if(!!searchParam.validationType && !!searchParam.validationType.code){
        valReq.validationType= searchParam.validationType.code;
      }
      if(!!searchParam.crewType && !!searchParam.crewType.crewTypeCode){
        valReq.crewType = searchParam.crewType.crewTypeCode;
      }

      return valReq;
    }

    CommonMasterData.getValidationTypeList(function(validationTypes) {
      vm.model.masterList.validationTypes = validationTypes;
    }, function() {
      console.log('Validation Type List retrieval error');
    });




  }
}());
